// Module
var code = `<p translate-once="front_royal_form.share_buttons.share"></p><ul><li ng-repeat="button in buttons"><button class="{{button.name}}" type="button" ng-click="share(button.name)"><i class="{{button.icon}}"></i> {{ 'front_royal_form.share_buttons.' + button.name | translate }}</button></li></ul>`;
// Exports
export default code;